<script setup>
import HomeMonolith from './components/HomeMonolith.vue'
</script>

<template>
  <HomeMonolith />
</template>
